import { render, staticRenderFns } from "./pendingPoliciesTable.vue?vue&type=template&id=2a744548&"
import script from "./pendingPoliciesTable.vue?vue&type=script&lang=js&"
export * from "./pendingPoliciesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports